import { App } from 'vue'
import LoadingCircle from './LpLoadingCircle.vue'

LoadingCircle.install = (Vue: App) => {
  Vue.component(LoadingCircle.name, LoadingCircle)
}

export default LoadingCircle
